module.exports = __webpack_public_path__ + "img/slide-19.45bf12d5.png";